"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _dateFromTSBuilder = _interopRequireDefault(require("./builders/dateFromTSBuilder"));

var _dateToTSBuilder = _interopRequireDefault(require("./builders/dateToTSBuilder"));

var _minimumStayMonthsBuilder = _interopRequireDefault(require("./builders/minimumStayMonthsBuilder"));

var _furnitureBuilder = _interopRequireDefault(require("./builders/furnitureBuilder"));

var _billsBuilder = _interopRequireDefault(require("./builders/billsBuilder"));

var _registrationBuilder = _interopRequireDefault(require("./builders/registrationBuilder"));

var _rulesBuilder = _interopRequireDefault(require("./builders/rulesBuilder"));

var _genderBuilder = _interopRequireDefault(require("./builders/genderBuilder"));

var _suitableForBuilder = _interopRequireDefault(require("./builders/suitableForBuilder"));

var _creationDateTSBuilder = _interopRequireDefault(require("./builders/creationDateTSBuilder"));

var _publishedDateTSBuilder = _interopRequireDefault(require("./builders/publishedDateTSBuilder"));

var _roomsBuilder = _interopRequireDefault(require("./builders/roomsBuilder"));

var _priceBuilder = _interopRequireDefault(require("./builders/priceBuilder"));

var _isSearchableBuilder = _interopRequireDefault(require("./builders/isSearchableBuilder"));

var _advertiserBuilder = _interopRequireDefault(require("./builders/advertiserBuilder"));

var _countryBuilder = _interopRequireDefault(require("./builders/countryBuilder"));

var _cityBuilder = _interopRequireDefault(require("./builders/cityBuilder"));

var _propertyTypeBuilder = _interopRequireDefault(require("./builders/propertyTypeBuilder"));

var _contractTypeBuilder = _interopRequireDefault(require("./builders/contractTypeBuilder"));

var _propertySizeBuilder = _interopRequireDefault(require("./builders/propertySizeBuilder"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var defaultBuilders = {
  dateFromTS: _dateFromTSBuilder["default"],
  dateToTS: _dateToTSBuilder["default"],
  minimumStayMonths: _minimumStayMonthsBuilder["default"],
  propertyType: _propertyTypeBuilder["default"],
  propertySize: _propertySizeBuilder["default"],
  contractType: _contractTypeBuilder["default"],
  furniture: _furnitureBuilder["default"],
  bills: _billsBuilder["default"],
  registration: _registrationBuilder["default"],
  rules: _rulesBuilder["default"],
  gender: _genderBuilder["default"],
  suitableFor: _suitableForBuilder["default"],
  creationDateTS: _creationDateTSBuilder["default"],
  publishedDateTS: _publishedDateTSBuilder["default"],
  rooms: _roomsBuilder["default"],
  priceEUR: _priceBuilder["default"],
  isSearchable: _isSearchableBuilder["default"],
  advertiser: _advertiserBuilder["default"],
  country: _countryBuilder["default"],
  city: _cityBuilder["default"]
};

var _default = function _default(builders) {
  if (builders === void 0) {
    builders = {};
  }

  return function (params, context) {
    var buildersSet = __assign(__assign({}, defaultBuilders), builders);

    var filterParts = Object.keys(buildersSet).map(function (key) {
      return buildersSet[key](params, context);
    });
    return filterParts.filter(Boolean).join(' AND ');
  };
};

exports["default"] = _default;